var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "20 40 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8-930.7h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8-936.1-881.2-930.7-887.8-930.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8-702h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12V-714C-875.8-707.4-881.2-702-887.8-702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8-473.4h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8-478.8-881.2-473.4-887.8-473.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8-244.7h-133.9c-6.6,0-12-5.4-12-12v-133.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8-250.1-881.2-244.7-887.8-244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8-16.1h-133.9c-6.6,0-12-5.4-12-12V-162c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8-21.5-881.2-16.1-887.8-16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8,212.5h-133.9c-6.6,0-12-5.4-12-12V66.7c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8,207.1-881.2,212.5-887.8,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8,441.2h-133.9c-6.6,0-12-5.4-12-12V295.3c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8,435.8-881.2,441.2-887.8,441.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline"
    },
    d: "M-887.8,669.8h-133.9c-6.6,0-12-5.4-12-12V523.9c0-6.6,5.4-12,12-12h133.9 c6.6,0,12,5.4,12,12v133.9C-875.8,664.4-881.2,669.8-887.8,669.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    d: "M106.1,51c-0.3-0.6-1-1-1.7-1H36c-0.7,0-1.3,0.4-1.7,1c-0.3,0.6-0.3,1.4,0.1,1.9L59.8,89v45.3 c0,0.7,0.4,1.4,1.1,1.7c0.2,0.1,0.5,0.2,0.8,0.2c0.5,0,0.9-0.2,1.3-0.5l17.1-15.3c0.4-0.4,0.6-0.9,0.6-1.4V89L106,52.9 C106.4,52.3,106.5,51.6,106.1,51z M77.3,87.4C77.3,87.4,77.3,87.4,77.3,87.4c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.1 c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0v29.7l-13.4,11.9V88.4c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1 c0,0,0,0,0,0L39.6,53.7h61.2L77.3,87.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.a9f3638c5b7ab39418964ec7b7a572d5.svg";
export { ForwardRef as ReactComponent };